import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import Button from "../../../../components/common/button/Button";
import styles from "./AdditionalMaterials.scss";
import { Form, FormGroup } from "react-bootstrap";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { getUserData, getUserDataById } from "../../../../actions/user.actions";
import SocialInputs from "../../completeProfile/components/SocialInputs";

class AdditionalMaterials extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { memberId } = this.props;
    if (memberId) {
      this.props.getUserDataById(memberId);
    } else {
      this.props.getUserData();
    }
  }

  updateSocialLinks(state) {
    this.setState({ social: state.social, socialValid: state.formValid });
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.additionalMaterials}>
          <div className={styles.content}>
            <h2 className={styles.title}>Additional Materials</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.subtitle}>
                    All the news that can’t fit: upload a resumé (max 2MB), link
                    out to your portfolio or personal website, and share your
                    LinkedIn profile.
                  </div>
                </FormGroup>
                <FormGroup>
                  <SocialInputs
                    links={this.props.links}
                    updateSocial={state => this.updateSocialLinks(state)}
                    col={8}
                    formName="additionalMaterials"
                    dispatch={this.props.dispatch}
                  />
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    isLoading={this.props.saving}
                    label="Save Changes"
                    loadingText="Saving..."
                    isDisabled={!valid || submitting || this.props.saving}
                  />
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

AdditionalMaterials = reduxForm({
  form: "additionalMaterials",
  enableReinitialize: true
})(AdditionalMaterials);

AdditionalMaterials = connect(
  state => {
    return {
      user: state.user.data,
      initialValues: state.user.data,
      saving: state.user.loading
    };
  },
  dispatch => {
    return {
      getUserData: () => dispatch(getUserData()),
      getUserDataById: id => dispatch(getUserDataById(id))
    };
  }
)(AdditionalMaterials);

export default AdditionalMaterials;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/AdditionalMaterials.js